// @flow
import React, { type Element } from 'react';
import { Track } from 'angieslist-app-platform';
import { Button, Modal } from 'angieslist-react-components';
import './howDisplayedModal.scss';

type Props = {
  categoryId: ?number,
};

type State = {
  open: boolean,
};

class HowDisplayedModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { open: false };
  }
  state: State;
  componentWillUnmount() {
    this.setState(() => ({ open: false }));
  }
  props: Props;

  render(): Element<"div"> {
    const { categoryId } = this.props;
    const handleClose = () => this.setState(() => ({ open: false }));
    return (
      <div>
        <Modal
          show={this.state.open}
          // onHide={() => this.setState(() => ({ open: false }))}
          onHide={handleClose}
          id="sp-profile-how-displayed-modal"
          title="How are companies displayed?"
        >
          <Modal.Body>
            <p><strong>What information is included in search results?</strong></p>
            <ul>
              <li><strong>Star Rating:</strong> Averages all reviews submitted on the Business
              in a particular category. If the category is unknown then the star rating is
              calculated from all reviews submitted on the Business.
              </li>
              <li><strong>Reviews:</strong> The number of reviews in the particular category. If
            the category is unknown then the number of reviews across all categories.
              </li>
              <li><strong>Coupons:</strong> Displayed in the provider listings and on the provider
            profile pages, these discounts are a benefit to Angi members.
              </li>
            </ul>
            <p><strong>How are service providers displayed?</strong></p>
            <p>
              Service providers are sorted by a combination of factors associated with positive
              member experiences. We occasionally test refinements to our search results and
              sort orders, which can vary the criteria and search results.  Certified Pros are
              placed at the top of the search results. Certified Pros must offer a discount
              to Angi members unless they are legally restricted from offering discounts
              for their goods or services.
            </p>
          </Modal.Body>
        </Modal>
        <div className="how-companies-are-displayed-button">
          <Track>
            <Button
              bsStyle="link"
              className="text-info"
              bsSize="small"
              style={{ fontSize: 12.8, paddingBottom: 5, textDecoration: 'none' }}
              data-track-categoryid={categoryId}
              id="sp-profile-how-companies-displayed-link"
              onClick={() => this.setState(() => ({ open: true }))}
            >
              How are companies displayed?
            </Button>
          </Track>
        </div>
      </div>
    );
  }
}

export default HowDisplayedModal;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/HowDisplayedModal.js